import React, { useContext } from 'react';
import PaperSection from '../../../../components/PaperSection/PaperSection';
import { Grid } from '@mui/material';
import FinancialSummaryItem from './FinancialSummaryItem';
import { ReportContext } from '../../../../common/reportContext';

interface FinancialSummaryProps {
  reportLayout?: boolean;
}

const FinancialSummary = (props: FinancialSummaryProps) => {
  const { report } = useContext(ReportContext);

  const financialRelationshipSummary = report.cashBoard.financialRelationshipSummary;
  const columns = props.reportLayout ? { xs: 3, lg: 3 } : undefined;

  return (
    <PaperSection title="Financial Relationship Summary">
      <Grid
        container
        rowSpacing={5}
        columnSpacing={3}
        sx={{
          textAlign: 'center'
        }}
      >
        <FinancialSummaryItem
          quantity={financialRelationshipSummary.bankingRelationships}
          type="Banking Relationships"
          detail={`${financialRelationshipSummary.bankingRelationshipsAccounts} accounts`}
          order={{ xs: 1, lg: 1 }}
          columns={columns}
        />

        <FinancialSummaryItem
          quantity={financialRelationshipSummary.investmentRelationships}
          type="Investment Relationships"
          detail={`${financialRelationshipSummary.investmentRelationshipsAccounts} accounts`}
          order={{ xs: 2, lg: 3 }}
          columns={columns}
        />

        <FinancialSummaryItem
          quantity={financialRelationshipSummary.changeInBankingAccounts}
          type="Change in bank accounts"
          displayDirection={Boolean(financialRelationshipSummary.changeInBankingAccounts)}
          order={{ xs: 3, lg: 2 }}
          columns={columns}
        />

        <FinancialSummaryItem
          quantity={financialRelationshipSummary.changeInInvestmentAccounts}
          type="Change in investment accounts"
          displayDirection={Boolean(financialRelationshipSummary.changeInInvestmentAccounts)}
          order={{ xs: 4, lg: 4 }}
          columns={columns}
        />
      </Grid>
    </PaperSection>
  );
};

export default FinancialSummary;
